define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    const invitation_model = require('civicsModels/portal/authorized_user_invitation_model');
    const constants = require('civicsUtils/constants');
    const urlBuilder = require('civicsUtils/buildUrlParameters');

    return IpsModelCollection.extend({
        model: invitation_model,
        urlRoot: '/delegate/civics-api/api/portal/organizations', 
        url: function() {
            var ret = this.urlRoot;

            if (this.organizationId) {
                ret += '/' + this.organizationId + '/invitations/?Filter={property:InviteCancelledDate,operator:IsNull}';
            }

            if (this.urlParameters) {
				ret += urlBuilder.buildUrlParameters(this.urlParameters);
			}

            if(ret.indexOf('includecount')>=0){
				if(ret.indexOf('?')<0){
					ret+='?';
				} else {
					ret+='&';
				}
				ret+='gettotalcount=true';
			}


            return ret;
        },
        parse: function(response) {
            var data = response.data;
            
			//if the collection is supposed to manage the has more records flag, 
			//we need to check for the extra record, and remove the last one.

            if (this.manageHasMoreRecords === true && this.hasMoreRecordsCheckSize == response.data.length) {
				data.pop();
				this.hasMoreRecords = true;
			} else {
				this.hasMoreRecords = false;
			}
            
            return data;
        }
    });
});